import { render, staticRenderFns } from "./PaymentBlocked.vue?vue&type=template&id=28caf2c0&scoped=true"
import script from "./PaymentBlocked.vue?vue&type=script&lang=js"
export * from "./PaymentBlocked.vue?vue&type=script&lang=js"
import style0 from "./PaymentBlocked.vue?vue&type=style&index=0&id=28caf2c0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28caf2c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28caf2c0')) {
      api.createRecord('28caf2c0', component.options)
    } else {
      api.reload('28caf2c0', component.options)
    }
    module.hot.accept("./PaymentBlocked.vue?vue&type=template&id=28caf2c0&scoped=true", function () {
      api.rerender('28caf2c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PaymentBlocked.vue"
export default component.exports